
import { MailSettings } from "@/models/mail-settings";
import { MailSettingsService } from "@/services/mail-settings-service";
import Vue from "vue";
import { AWSFileService } from "@/services/aws-file-service";
import AppMailSettingsServer from "@/components/settings-default/MailSettingsEmailServer.vue";


export default Vue.extend({
	props: {
		mailSettings: {
			type: Object as ()=>MailSettings,
			required: true
		},
		unsavedChanges: Boolean
	},
	methods: {
		async save() {
			if (!this.mailSettings) return;
			let result = await MailSettingsService.updateSettings(this.mailSettings,	false);
			await this.$emit("mail-settings", result);
			this.$wf.notify(
				this.$t("common.success").toString(),
				"success",
				3000,
				"check"
			);
		},
		async handlerImageAdded(file: File,Editor: any,cursorLocation: number,resetUploader: any) {
			let awsFile = await AWSFileService.uploadFile(
				"/email-signature",
				file
			);
			let url = awsFile.getUrl();
			Editor.insertEmbed(cursorLocation, "image", url);
			resetUploader();
		},
		onSettingsSaved(settings:MailSettings){
			this.$emit("mail-settings", settings);
		}
	},
	components: {
		VueEditor: () => import("@/utils/vue-editor"),
		AppMailSettingsServer
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
